import { useMemo } from 'react';
import { isUndefined } from 'lodash-es';
import { css } from '@emotion/css';
import { useTranslate } from '@tolgee/react';

import {
  isMabangChannel,
  mabangChannelHash,
  qianyiChannelHash,
  upfosChannelHash,
  yicangChannelHash,
  zhixiaChannelHash,
} from 'services/chattt/channels/const';
import yicangLoginLogo from 'assets/channels/yicang/hezuo-logo.svg';
import yicangSiderLogo from 'assets/channels/yicang/yicanglogo.svg';

import mabangLoginLogo from 'assets/channels/mabang/loginLogo.svg';
import mabangSiderLogo from 'assets/channels/mabang/siderLogo.svg';

import loginLogo from '../assets/channels/82ae902caedcb44ee581cf367acf90a3/hezuo-logo.svg';
import siderLogo, {
  ReactComponent as SiderLogoSvg,
} from '../assets/channels/82ae902caedcb44ee581cf367acf90a3/zhixialogo.svg';

import upfosLoginLogo from '../assets/channels/b98cb7f88ba8bafa4f492e6fe35f9141/loginLogo.svg';
import upfosSiderLogo from '../assets/channels/b98cb7f88ba8bafa4f492e6fe35f9141/siderLogo.svg';

import qianyiLoginLogo from '../assets/channels/018efbff9d9331443f54830359ae397b/loginLogo.svg';
import qianyiSiderLogo from '../assets/channels/018efbff9d9331443f54830359ae397b/siderLogo.svg';
import { chatttSDKChannel } from 'services/chattt/sdk';

const useChannelMateriel = () => {
  const { t } = useTranslate();

  return useMemo(() => {
    const CONFIG = {
      // 萌啦科技（知虾）
      [zhixiaChannelHash]: {
        loginLogo,
        siderLogo,
        serviceDocLink: undefined,
        // siderNav 的特殊权限目前建议通过flagr 进行管理
        // siderNav: {
        //   icon: menuIcon,
        //   label: 'nav.zhixia',
        //   path: '/zhixia',
        // },
        shops: {
          shopeeLogo: (
            <div
              className={css`
                height: 178px;
                width: 178px;
                padding: 10px;
                background-color: #fff3e6;
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 4px 0 0 4px;
              `}
            >
              <SiderLogoSvg color="#ee4e2d" />
            </div>
          ),
          shopeeDesc: t('ViewAppCenter.知虾desc'),
        },
      },
      [yicangChannelHash]: {
        loginLogo: yicangLoginLogo,
        siderLogo: yicangSiderLogo,
        serviceDocLink: undefined,
      },
      [mabangChannelHash]: {
        loginLogo: mabangLoginLogo,
        siderLogo: mabangSiderLogo,
        serviceDocLink: `${process.env.PUBLIC_URL}/mabang_service.htm`,
      },
      [upfosChannelHash]: {
        loginLogo: upfosLoginLogo,
        siderLogo: upfosSiderLogo,
        serviceDocLink: undefined,
      },
      [qianyiChannelHash]: {
        loginLogo: qianyiLoginLogo,
        siderLogo: qianyiSiderLogo,
        serviceDocLink: undefined,
      },
    } as const;

    if (!chatttSDKChannel) {
      return { CONFIG };
    }
    let config = CONFIG[chatttSDKChannel as keyof typeof CONFIG];
    if (isMabangChannel) {
      config = CONFIG[mabangChannelHash];
    }
    return {
      CONFIG,
      opened: !isUndefined(config),
      config,
    };
  }, [t]);
};

export default useChannelMateriel;
